import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UtensilsCrossed } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "../lib/format";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-emerald-50 dark:from-slate-950 dark:to-slate-900 p-6">
      <div className="w-full max-w-md">
        <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xl border border-border p-8">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-xl bg-emerald-600 flex items-center justify-center text-white">
              <UtensilsCrossed size={22} />
            </div>
            <div>
              <div className="heading text-2xl font-extrabold tracking-tight">Food Payment Tracker</div>
              <div className="text-sm text-muted-foreground">Daily food ledger for teams</div>
            </div>
          </div>
          <h1 className="heading text-xl font-bold mb-1">Administrator Sign In</h1>
          <p className="text-sm text-muted-foreground mb-6">Enter your credentials to manage orders and payments.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email address</Label>
              <Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@gmail.com" className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="mt-1.5" />
            </div>
            <Button type="submit" data-testid="login-submit" className="w-full bg-emerald-600 hover:bg-emerald-700 mt-2" disabled={loading}>
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
          <div className="mt-6 pt-4 border-t border-border text-xs text-muted-foreground">
            <div className="font-medium text-slate-700 dark:text-slate-300 mb-1">By fj apps</div>
            <div className="mono"></div>
            <div className="mono"></div>
            <a href="/portal/login" className="mt-3 inline-block text-teal-700 hover:underline" data-testid="link-emp-login">Employee login →</a>
          </div>
        </div>
      </div>
    </div>
  );
}
